module.exports = __webpack_public_path__ + "img/PXioNf1l-EmRPaQ,Scan0002.e10c7888.jpeg";